import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { selectAuthenticated, selectUser } from '../store/authentication/authentication.selector';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../store/reducer';

export function isAuthenticated(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const store = inject(Store<State>);
    const router = inject(Router);

    return combineLatest([store.select(selectAuthenticated), store.select(selectUser)]).pipe(
        map(([authenticated, user]) => {
            if (!authenticated || !user) {
                void router.navigate(['/auth/sign-in']);
            }
            return !!authenticated && !!user;
        })
    );
}

export function canAccess(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const store = inject(Store<State>);

    return store.select(selectUser).pipe(
        map((user) => {
            let allowedToAccess = false;
            const allowedRoles = route.data['allowedRoles'] ?? [];

            if (user) {
                for (const role of allowedRoles) {
                    allowedToAccess = user.roles?.includes(role) ?? false;
                    if (allowedToAccess) {
                        break;
                    }
                }
            }

            return allowedToAccess;
        })
    );
}
